module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


  var labelText = typeof label === 'string' ? label : '';
  var screenValue = typeof screen === 'string' ? screen : undefined;

  switch (screenValue) {
    case 'forgotPassword':
      labelText = labelText || 'Forgot Password?';
      break;
    case 'login':
      labelText = labelText || 'Sign in here';
      break;
    case 'register':
      labelText = labelText || 'Register';
      break;
  }
;
__p += '\n\n<button\n  type="button"\n  class="' +
((__t = ( styles.screenLink )) == null ? '' : __t) +
'"\n  ';
 if (typeof screenValue === 'string') { ;
__p += '\n  data-show-screen="' +
((__t = ( screenValue )) == null ? '' : __t) +
'"\n  ';
 } else if (typeof action === 'string') { ;
__p += '\n  data-screen-action="' +
((__t = ( action )) == null ? '' : __t) +
'"\n  ';
 } ;
__p += '\n  ';
 if (typeof meta === 'object' && meta !== null) { ;
__p += '\n    ';
 for (var prop in meta) { ;
__p += '\n      data-' +
((__t = ( prop )) == null ? '' : __t) +
'="' +
((__t = ( meta[prop] )) == null ? '' : __t) +
'"\n    ';
 } ;
__p += '\n  ';
 } ;
__p += '\n>\n  ' +
((__t = ( labelText )) == null ? '' : __t) +
'\n</button>\n';

}
return __p
}